import {toastr} from 'react-redux-toastr'
import { I18n } from 'react-redux-i18n';
export default function errorMessage(err){
  
  if(err.message){
    toastr.error('Error', I18n.t(err.message));
  }
  return Promise.reject();
}